import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './SomethingErrorFactorView.scss';

export const SomethingErrorFactorView = props => {
  const { handleClickTryAgain } = props;
  return (
    <FlexContainer
      className={
        'flex-column margtb24 marglr48 m-marglr16 dashboardSomethingError'
      }
    >
      <Label className={'Subtitle-1 margTB10 text-center m-padLR58'}>
        Sorry, something went wrong. Please,{' '}
        <span className="blueB100 pointer" onClick={handleClickTryAgain}>
          try again.
        </span>
      </Label>
      <TradelineSomethingError />
      <TradelineSomethingError />
      <TradelineSomethingError />
    </FlexContainer>
  );
};

const TradelineSomethingError = () => {
  return (
    <FlexContainer
      className={
        'flex-column grayShadow16 margt16 padlr30 padb24 padt30 m-padt18 m-pad10 border-rad8px'
      }
    >
      <FlexContainer className="gap-20">
        <FlexContainer className="flex-column width100">
          <FlexContainer className="line-box-noanimated" />
          <FlexContainer className="margt20 line-box-noanimated" />
          <FlexContainer className="margt20 line-box-noanimated" />
        </FlexContainer>
        <FlexContainer className="flex-column">
          <FlexContainer className="image-noanimated" />
          <FlexContainer className="margt12 line-box-noanimated" />
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className="margt16 tradeline-box-noanimated border-rad8px" />
    </FlexContainer>
  );
};
